import auth0, { WebAuth, Auth0DecodedHash } from 'auth0-js';
import qs from 'query-string';

class Auth {
  auth0: WebAuth;

  idToken?: string;

  expiresAt?: number;

  constructor() {
    if (!process.env.REACT_APP_AUTH_CONFIG_DOMAIN || !process.env.REACT_APP_AUTH_CONFIG_CLIENT_ID) {
      throw new Error('auth0 domain and clientID are required');
    }

    const params = qs.parse(window.location.search);

    let redirectUri = `${process.env.REACT_APP_APP_URI}/callback`;

    if (window.location.pathname.includes('bridge-signup')) {
      redirectUri = `${process.env.REACT_APP_APP_URI}/bridge-signup${
        params.cohort_code ? `?cohort_code=${params.cohort_code}` : ''
      }`;
    }

    this.auth0 = new auth0.WebAuth({
      domain: process.env.REACT_APP_AUTH_CONFIG_DOMAIN,
      clientID: process.env.REACT_APP_AUTH_CONFIG_CLIENT_ID,
      redirectUri,
      responseType: 'id_token',
      scope: 'openid',
    });

    const idToken = localStorage.getItem('idToken');
    const expiresAt = localStorage.getItem('expiresAt');

    if (idToken) {
      this.idToken = idToken;
    }

    if (expiresAt) {
      this.expiresAt = JSON.parse(expiresAt);
    }
  }

  login() {
    this.auth0.authorize({
      // @ts-ignore
      form_mode: 'login',
      partners_api_url: process.env.REACT_APP_PLATFORM_API_URI,
      partners_client_url: process.env.REACT_APP_PLATFORM_URI,
    });
  }

  logout() {
    this.auth0.logout({
      returnTo: process.env.REACT_APP_APP_URI,
      clientID: process.env.REACT_APP_AUTH_CONFIG_CLIENT_ID,
    });
  }

  handleAuthentication(): Promise<Auth0DecodedHash> {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (err) {
          reject(err);
          return;
        }

        if (authResult) {
          this.setSession(authResult);
          resolve(authResult);
        } else {
          reject();
        }
      });
    });
  }

  renewSession(): Promise<Auth0DecodedHash> {
    return new Promise((resolve, reject) => {
      this.auth0.checkSession({}, (err, authResult) => {
        if (err) {
          reject(err);
          return;
        }

        this.setSession(authResult);

        resolve(authResult);
      });
    });
  }

  setSession(authResult: Auth0DecodedHash) {
    if (
      !authResult.idToken ||
      !authResult.idTokenPayload ||
      (authResult.idTokenPayload && !authResult.idTokenPayload.exp)
    ) {
      return;
    }

    this.idToken = authResult.idToken;
    this.expiresAt = authResult.idTokenPayload.exp * 1000;

    localStorage.setItem('idToken', this.idToken);
    localStorage.setItem('expiresAt', JSON.stringify(this.expiresAt));
  }

  getIdToken(): string | undefined {
    return this.idToken;
  }

  isAuthenticated(): boolean {
    if (!this.expiresAt) return false;

    return Date.now() < this.expiresAt;
  }
}

export const auth = new Auth();

export default Auth;
